import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class SmsPushNotificationService {

  constructor(private http:HttpClient,public baseURL :BasemodelService) { }

getcity(){
  return this.http.get('https://testmasters.scaits.net/apiV2/common/empCities')
}
getcampus(cityId:any){
  return this.http.get('https://testmasters.scaits.net/apiV2/common/empCityCampuses?cityId='+cityId)
}
getsection(campusId:any){
  return this.http.get('https://testmasters.scaits.net/apiV2/common/getCampusSections?campusId='+campusId)
}
gettemplate(){
  return this.http.get('https://testnotification.scaits.net/employee/api/jwtV2/getNotificationTypes')
}
  

}
